import React from 'react';
import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer,
} from 'recharts';


const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

class ProcessMatuirityModel extends React.Component {
  componentDidMount() {
    this.animateArrowPointers('all');
    this.animateArrowPointers('policy');
    this.animateArrowPointers('practice');
    this.animateArrowPointers('platform');
  }

  getPreparedData(category) {
    const data = JSON.parse(JSON.stringify(this.props.data))
    console.log(data);
    let categoryData = data[category];
    if (!categoryData || categoryData.length === 0) {
    categoryData = [
      {'label': '*', value: 0, value2: 0, max: 4},
      {'label': '*', value: 0, value2: 0, max: 4},
      {'label': '*', value: 0, value2: 0, max: 4},
    ]
    } else if (categoryData.length === 1) {
      categoryData.push({'label': '*', value: 0, value2: 0, max: 4});
      categoryData.push({'label': '*', value: 0, value2: 0, max: 4});
    } else if (categoryData.length === 2) {
      categoryData.push({'label': '*', value: 0, value2: 0, max: 4});
    }
    // Letters and numbers are coming from here
    for(let i = 0, length = categoryData.length; i < length; i += 1) {
      categoryData[i]['index'] = letters[i];
      categoryData[i]['max'] = 4;
    }
    return categoryData;
  }

  getAverageData(category) {
    const { data } = this.props;
    let categoryData = [];
    if (category === 'all') {
      categoryData = categoryData.concat(data['policy'], data['practice'], data['platform']);
    } else {
      categoryData = data[category];
    }
    let sum = 0;
    for(let i = 0, length = categoryData.length; i < length; i += 1) {
      sum += categoryData[i]['value'];
    }
    if (categoryData.length === 0) {
      return 0.02234636871;
    }
    return (sum / categoryData.length);
  }

  rendertable(data) {
    return (
      data.map((rowData, index) => (
        <div className="row range-data" key={index}>
          <div className="col first-col"><div>{ rowData['index'] }. { rowData['label'] }</div></div>
          <div className="col-2 second-col"><div>{ rowData['value'] === 0 ? '-' : rowData['value'] }</div></div>
          <div className="col-2  last-col"><div>{ rowData['value2'] === 0 ? '-' : rowData['value2'] }</div></div>
          {/*<div className="col-2 last-col"><div>{ rowData['max'] }</div></div>*/}
        </div>))
    );
  }

customTick = (e) => {
  return (
    <g>
    <text
      fill="#ccc"
      x={e.x}
      y={e.y}
      radius={e.radius}
      className="recharts-text recharts-polar-radius-axis-tick-value"
      textAnchor={e.textAnchor}>
      <tspan x={e.x} dy="0em">{e.payload.value}</tspan>
    </text>
    </g>
  );
}

customRadiusTick = (e) => {
  return (
    <text
      fill="#ccc"
      x={e.x}
      y={e.y}
      radius={e.radius}
      className="recharts-text"
      textAnchor={e.textAnchor}>
      <tspan x={e.x} dy="1em">{e.payload.value}</tspan>
    </text>
  )
}

animateArrowPointers(category) {
  const style = document.createElement('style');
  style.type = 'text/css';
  var keyFrames = `\
  @-webkit-keyframes animate-arrow-${category} {\
      100% {\
          -webkit-transform: rotate(${this.getAverageData(category)  / 4 * 179}deg);\
      }\
  }\
  @keyframes animate-arrow-${category} {\
      100% {\
          -webkit-transform: rotate(${this.getAverageData(category)  / 4 * 179}deg);\
      }\
  }`;
  style.innerHTML = keyFrames.replace(this.getAverageData(category)  / 4 * 179, "180deg");
  document.getElementsByTagName('head')[0].appendChild(style);
}

  render() {
    return (
      <div className="charts-container h-103 w-100 m-0 p-0">
        <div className="rounded-charts-container row">
          <div className="col h-100 rounded-chart-col">
            <div className="header-container">
              Overall
            </div>
            <div className="average-container">
              { this.getAverageData('all').toFixed(1) }
            </div>
            <div className="arrow-pointer overall-pointer"></div>
          </div>
          <div className="col h-100 rounded-chart-col">
            <div className="header-container">
              Policy
            </div>
            <div className="average-container">
              { this.getAverageData('policy').toFixed(1) }
            </div>
            <div className="arrow-pointer policy-pointer"></div>
          </div>
          <div className="col h-100 rounded-chart-col">
            <div className="header-container">
              Practice
            </div>
            <div className="average-container">
              { this.getAverageData('practice').toFixed(1) }
            </div>
            <div className="arrow-pointer practice-pointer"></div>
          </div>
          <div className="col h-100 rounded-chart-col">
            <div className="header-container">
              Platform
            </div>
            <div className="average-container">
              { this.getAverageData('platform').toFixed(1) }
            </div>
            <div className="arrow-pointer platform-pointer"></div>
          </div>
        </div>

        <div className="radar-charts-container row">

          <div className="col-4 h-100 left-radar radar-col">
            <div className="header-container">
              Policy - As Is Vs To-Be PMM Score
            </div>
            <div className="radar-content">
              <ResponsiveContainer width="100%" height="65%">
                <RadarChart
                    data={this.getPreparedData('policy')}
                >
                  <PolarGrid />
                  {/*ABCs*/}
                  <PolarAngleAxis dataKey="index" tick={this.customTick} />
                  {/*Numbers*/}
                  <PolarRadiusAxis
                      domain={[0, 4]} orientation="middle" axisLine={false} angle={90} tick={this.customRadiusTick}
                  />
                  {/*orange curve*/}
                  <Radar name="asis" dataKey="value" stroke="#FA9917" fill="transparent" fillOpacity={0.6} />
                  {/*teal curve*/}
                  <Radar name="tobe" dataKey="value2" stroke="#33E1FF" fill="transparent" fillOpacity={0.6} />
                </RadarChart>
              </ResponsiveContainer>
            </div>
            {/*this is bottom legend */}
            <div className="radar-values-table row">
              <div className="head row">
                <div className="col first-col"><div>PMM Questionnaire</div></div>
                <div className="col-2 second-col"><div>As-is</div></div>
                <div className="col-2 last-col"><div>To-Be</div></div>
              </div>
              { this.rendertable(this.getPreparedData('policy')) }
            </div>
          </div>

          <div className="col-4 h-100 center-radar radar-col">
            <div className="header-container">
              Practice - As Is Vs To-Be PMM Score
            </div>
            <div className="radar-content">
              <ResponsiveContainer width="100%" height="65%">
                <RadarChart data={this.getPreparedData('practice')}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey="index" tick={this.customTick} />
                  <PolarRadiusAxis domain={[0, 4]} orientation="middle" axisLine={false} angle={90} tick={this.customRadiusTick} />
                  <Radar name="" dataKey="value" stroke="#FA9917" fill="transparent" fillOpacity={0.6} />
                  {/*teal curve*/}
                  <Radar name="tobe" dataKey="value2" stroke="#33E1FF" fill="transparent" fillOpacity={0.6} />
                </RadarChart>
              </ResponsiveContainer>
            </div>
            <div className="radar-values-table row">
              <div className="head row">
                <div className="col first-col"><div>PMM Questionnaire</div></div>
                <div className="col-2 second-col"><div>As-is</div></div>
                <div className="col-2 last-col"><div>To-Be</div></div>
              </div>
              { this.rendertable(this.getPreparedData('practice')) }
            </div>
          </div>
          <div className="col-4 h-100 right-radar radar-col">
            <div className="header-container">
              Platform - As Is Vs To-Be PMM Score
            </div>
            <div className="radar-content">
              <ResponsiveContainer width="100%" height="65%">
                <RadarChart data={this.getPreparedData('platform')}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey="index" />
                  <PolarRadiusAxis domain={[0, 4]} orientation="middle" axisLine={false} angle={90} tick={this.customRadiusTick} />
                  <Radar name="" dataKey="value" stroke="#FA9917" fill="transparent" fillOpacity={0.6} />
                  {/*teal curve*/}
                  <Radar name="tobe" dataKey="value2" stroke="#33E1FF" fill="transparent" fillOpacity={0.6} />
                </RadarChart>
              </ResponsiveContainer>
            </div>
            <div className="radar-values-table row">
              <div className="head row">
                <div className="col first-col"><div>PMM Questionnaire</div></div>
                <div className="col-2 second-col"><div>As-is</div></div>
                <div className="col-2 last-col"><div>To-Be</div></div>
              </div>
              { this.rendertable(this.getPreparedData('platform')) }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProcessMatuirityModel;
